// handle timezones: https://momentjs.com/timezone/docs/#/using-timezones/guessing-user-timezone/
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import Toasted from 'vue-toasted'
import VeeValidate from 'vee-validate'
import axios from 'axios'
import VTooltip from 'v-tooltip'
import VModal from 'vue-js-modal'
import VueLazyload from 'vue-lazyload'

import App from './App.vue'
import HomePage from './pages/HomePage.vue'
import NotificatorsPage from './pages/NotificatorsPage.vue'
import NewMonitorPage from "./pages/NewMonitorPage.vue"
import MonitorPage from "./pages/MonitorPage.vue"
import MonitorPageEmpty from "./pages/MonitorPageEmpty.vue"
import AccountPage from "./pages/AccountPage.vue"
import LoginPage from "./pages/LoginPage.vue"

import Realtime from "./realtime"
import Account from "./account"
import store from './store'

Vue.use(VueLazyload, {
  preLoad: 1.3,
  // error: 'https://cdn0.iconfinder.com/data/icons/Hand_Drawn_Web_Icon_Set/128/bullet_error.png',
  error: 'https://s3.amazonaws.com/pagespy/loading.svg',
  loading: 'https://s3.amazonaws.com/pagespy/loading.svg',
  attempt: 10
})

// start ticking
store.dispatch('tick')

window._ = require('lodash');

const account = new Account;

// I don't know if we should do this now
if(true) {
  const WS_SERVER = (process.env.NODE_ENV == "development") ? 'wss://api.dev.pagespy.io/ws' : 'wss://api.pagespy.io/ws';
  let realtime = new Realtime(WS_SERVER, localStorage.getItem('AccountID'));
  realtime.connect();
}


var user;
if(user = localStorage.getItem('user')) {
  const user = JSON.parse(user);
}

const APIToken = localStorage.getItem("APIToken")
const AccountID = localStorage.getItem("AccountID")

const titleSuffix = " | pagespy.io"
const routes = [
  {
    path: '/',
    component: HomePage,
    children: [
      { path: "/", component: MonitorPageEmpty, name: 'monitors.home', meta: { title: "Your monitors" }},
      { path: '/monitors/new', component: NewMonitorPage, name: "monitors.new", meta: { title: "Create new monitor" }},
      { path: "monitors/:id", component: MonitorPage, name: 'monitors.show', meta: { title: "Edit monitor" }},
    ],
    meta: { title: "Dashboard" }
  },
  { path: '/notificators', component: NotificatorsPage, name: "notificators.index", meta: { title: "Notificators"} },
  { path: '/account', component: AccountPage, name: "account.index", meta: { title: "Account Settings"} },
  { path: '/login', component: LoginPage, name: "login.index", meta: { title: "Login to PageSpy"} },
]

const router = new VueRouter({
  // mode: 'history',
  base: "/",
  routes: routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title + titleSuffix

  if(window._.isUndefined(AccountID)) {
    next('/login');
    next(false)
  }

  next()
})

const axiosInstance = axios.create({
    baseURL: (process.env.NODE_ENV == "development") ? 'https://api.dev.pagespy.io/v1' : 'https://api.pagespy.io/v1',
    timeout: 5000,
    headers: {
        'Token': localStorage.getItem("APIToken") ? localStorage.getItem('APIToken') : false
    }
});

Vue.prototype.$http = axiosInstance

Vue.mixin({
  data: function() {
    return {
      get imageHost() {
        // return (process.env.NODE_ENV == "development") ? "https://images.dev.pagespy.io" : "https://images.pagespy.io";
        return "https://snapshots.nyc3.digitaloceanspaces.com";
      },
      get currentUser() {
        return {
          APIToken: localStorage.getItem("APIToken"),
          AccountID: localStorage.getItem("AccountID")
        }
      }
    }
  }
})


if(_.isNull(APIToken) || _.isNull(AccountID)) {
  window.location = "/#/login";
}

function onTelegramAuth(user) {
  console.log(user);

  axiosInstance.post("/notificators", {
    type: "telegram",
    properties: user
  }).then(response => {

    // do some things in here, show success message and all that
    console.log(response);
  })
}

window.onTelegramAuth = onTelegramAuth

Vue.config.devtools = true;

console.log("NODE ENV: ", process.env.NODE_ENV);


Vue.use(VueRouter)
Vue.use(VueMoment, { 
  moment,
})
Vue.use(VTooltip)
Vue.use(VeeValidate, {
  classes: true
});
Vue.use(VModal)

Vue.use(Toasted, {
  containerClass: 'changenotify-toasted',
  //duration: 5000,
  action: [
    { text : 'x', onClick : (e, toastObject) => { toastObject.goAway(0); } },
  ]
})

Vue.filter('substr',  (value, from, to) => {
      if (!value) return ''
      value = value.toString()
      return (value.length > to) ? value.substr(from, to) + ' ...' : value
})

Vue.toasted.register('app_error', 'Oops.. Something Went Wrong..', {
  type : 'error',
  icon : 'error_outline'
})

window.App = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js